import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { fetchAlertHistories, getAlertHistories, getAlerts } from '../../../Alert/slice/slice'
import { useDispatch } from 'react-redux'
import { OlangItem } from '../../../shared/Olang/user-interface/OlangItem/OlangItem'
import moment from 'moment'
import { Button } from 'primereact/button'
import { useNavigate } from 'react-router-dom'

function AlertCardView() {
  let alerts = useSelector(getAlertHistories)
  
  const navigate = useNavigate()
  const dispatch = useDispatch();
 
  function getIcon(alert){
    let condition = alert.condition || ''
    if(condition.includes('temperature')) return "fa-regular fa-temperature-full"
    else if(condition.includes('humidity')) return "fa-duotone fa-regular fa-droplet-degree"
    return "pi pi-bell"
  }

  

  useEffect(()=>{
    dispatch(fetchAlertHistories({
        isEnd: 0,
        isRead:0
    }))
  }, [])
  return (
    <div>
        {
            alerts.map(o =>(
                <div className='p-2 bg-white'>
                    <div className='p-3 border-1  border-red-100 border-round-md'>
                        <div className='flex gap-3 align-items-center'>
                            <div className='bg-red-50 border-round-md text-red-600 flex align-items-center justify-content-center' 
                                 style={{width: '4rem' , height: '4rem'}}>
                                <span className={`${getIcon(o)} text-2xl`}></span>
                            </div>
                            <div >
                                <div className='font-semibold mb-1'>{o.alertCode}</div>
                                <div className='p-1 border-round-sm bg-blue-400 text-white inline-block'>
                                    {o.condition}
                                </div>
                            </div>
                        </div>
                        <div className='my-5'>
                            {o.message}
                        </div>

                        <div className='bg-red-50 border-1 border-round-md border-red-100 flex py-2 px-5 align-items-center justify-content-between'>
                            <div>
                                <OlangItem olang="start"/>
                                <div>
                                    <span className='font-semibold'>{moment(o.startDate).utc().format('DD/MM/YYYY')}</span>
                                    <span className='block'>{moment(o.startDate).utc().format('HH:mm')}</span>
                                </div>
                            </div>
                            <div>
                                <OlangItem olang="end"/>
                                <div>
                                    <span className='font-semibold'>{moment(o.endDate).utc().format('DD/MM/YYYY')}</span>
                                    <span className='block'>{moment(o.endDate).utc().format('HH:mm')}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ))
        }
    </div>
  )
}

export default AlertCardView